import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import DropdownMenu from '../../shared/dropdownMenu';

import {
  generateAndDownloadXlsxTemplateForConnectionBeginningBalances,
  generateXlsxTemplateForCompany,
} from './generateXLSXTemplate';

import { companyCodePropType, connectionTemplatesDetailsPropType } from './propTypes';

class HamburgerDropdown extends PureComponent {
  static propTypes = {
    adjustmentPeriod: PropTypes.string,
    companyCodeData: companyCodePropType,
    cannotImportBeginningBalances: PropTypes.bool.isRequired,
    disableImportBeginningBalancesButton: PropTypes.bool.isRequired,
    disableImportBatchBeginningBalancesButton: PropTypes.bool.isRequired,
    showImportBeginningBalancesModal: PropTypes.func.isRequired,
    showImportBatchBeginningBalancesModal: PropTypes.func.isRequired,
    connection: PropTypes.string.isRequired,
    connectionTemplateDetails: connectionTemplatesDetailsPropType,
    environmentSuffix: PropTypes.string.isRequired,
  };

  showImportBeginningBalancesModal = () => {
    this.props.showImportBeginningBalancesModal({});
    this.dropdown.hideDropDown();
  };

  showImportBatchBeginningBalancesModal = () => {
    this.props.showImportBatchBeginningBalancesModal({});
    this.dropdown.hideDropDown();
  };

  generateTemplate = async () => {
    const {
      adjustmentPeriod,
      companyCodeData,
      connection,
      connectionTemplateDetails,
      environmentSuffix,
    } = this.props;

    if (companyCodeData) {
      generateXlsxTemplateForCompany({ adjustmentPeriod, companyCodeData, environmentSuffix });
    } else if (connectionTemplateDetails) {
      generateAndDownloadXlsxTemplateForConnectionBeginningBalances({
        adjustmentPeriod,
        connection,
        connectionTemplateDetails,
        environmentSuffix,
      });
    }
  };

  renderImportButton = ({ label, disabled, hidden, onClick }) => {
    if (hidden) {
      return null;
    }

    if (disabled) {
      return (
        <button
          className="hamburger-action link-button"
          tabIndex="0"
          disabled
        >
          {label}
        </button>
      );
    }

    return (
      <button
        onClick={onClick}
      >
        {label}
      </button>
    );
  };

  renderImportBeginningBalancesButton = () => {
    const {
      disableImportBeginningBalancesButton,
      cannotImportBeginningBalances,
    } = this.props;

    return this.renderImportButton({
      label: 'Import Beginning Balances',
      disabled: disableImportBeginningBalancesButton,
      hidden: cannotImportBeginningBalances,
      onClick: this.showImportBeginningBalancesModal,
    });
  };

  renderImportBatchBeginningBalancesButton = () => {
    const {
      disableImportBatchBeginningBalancesButton,
      cannotImportBeginningBalances,
    } = this.props;

    return this.renderImportButton({
      label: 'Import Batch Beginning Balances',
      disabled: disableImportBatchBeginningBalancesButton,
      hidden: cannotImportBeginningBalances,
      onClick: this.showImportBatchBeginningBalancesModal,
    });
  };

  render() {
    const { companyCodeData, connectionTemplateDetails } = this.props;

    return (
      <DropdownMenu ref={dropdown => this.dropdown = dropdown} contentClassName="hamburger-menu">
        <button
          className="hamburger-action link-button"
          onClick={this.generateTemplate}
          disabled={!companyCodeData && !connectionTemplateDetails}
        >
          Download Beginning Balance Template
        </button>

        {this.renderImportBatchBeginningBalancesButton()}
        {this.renderImportBeginningBalancesButton()}
      </DropdownMenu>
    );
  }
}

export default HamburgerDropdown;
